(function () {
    'use strict';

    angular.module('swif.interventions')

    .service('swifInterventionsService', swifInterventionsService);

    function swifInterventionsService(
        requestService, interventionService, taskService, interventionsPlanningService, ganttService
    ) {
        var service = {
            request: requestService,
            intervention : interventionService,
            task : taskService,
            planning : interventionsPlanningService,
            gantt : ganttService
        };
        return service;
    }
})();
